import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';

// assets
import { faCheck, faXmarkCircle } from '@fortawesome/pro-light-svg-icons';

// services
import ErrorService from '../../../../../services/general/error';
import VesselCrewService from '../../../../../services/vessels/crew';

// props

// components
import { DefaultButton, Panel, PanelType, PrimaryButton, Spinner, SpinnerSize, Stack } from '@fluentui/react';
import { IVesselCrewResourceProps } from '../../../../../props/vessels/crew';
import SelectVessel from '../../../../uiframeworks/forms/vessels';
import SelectVesselCrewRole from '../../../../uiframeworks/forms/data/vessels/crewRole';
import SelectEmployee from '../../../../uiframeworks/forms/selectEmployee';
import Text from '../../../../typography/text';

interface DeactivateVesselCrewFormProps {
    vesselId: string;
    crewId: string;
    onDismissed(refresh?: boolean, status?: string): void;
}

const DeactivateVesselCrewForm: React.FC<DeactivateVesselCrewFormProps> = (props: DeactivateVesselCrewFormProps) => {
    const { banner, user } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [submitting, setSubmitting] = React.useState<boolean>(false);
    const [crew, setCrew] = React.useState<IVesselCrewResourceProps | undefined>();

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            const _crew = await VesselCrewService.read(props.vesselId, props.crewId);
            setCrew(_crew);
            setLoaded(true);
        } catch (e) {
            banner.add({
                key: 'get_crew_error',
                variant: 'error',
                icon: faXmarkCircle,
                text: `Failed to get crew details. Error: ${ErrorService.getMessage(e)}`
            });
            props.onDismissed();
        }
    }

    const isSubmitButtonDisabled = (): boolean => {
        return false;
    }

    const _onSubmit = async () => {
        try {
            const confirmed = window.confirm("Are you sure you want to deactivate this crew?");

            if (confirmed) {
                setSubmitting(true);

                // create form data
                const fd = new FormData();

                await VesselCrewService.deactivate(props.vesselId, props.crewId, fd);
                banner.add({
                    key: 'deactivate_crew_success',
                    variant: 'success',
                    icon: faCheck,
                    text: `${crew?.user.name} has been deactivated from ${crew?.vessel.name}.`
                });
                props.onDismissed(true);
            }
        } catch (e) {
            setSubmitting(false);
        }
    }

    return <Panel headerText={'Deactivate Crew'}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismissed(false)}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                {
                    !submitting ? (
                        <>
                            <PrimaryButton text={"Deactivate"} disabled={isSubmitButtonDisabled()} onClick={_onSubmit} />
                            <DefaultButton text={"Cancel"} onClick={() => { props.onDismissed(false) }} />
                        </>
                    ) : null
                }
                {submitting ? <Spinner size={SpinnerSize.medium} labelPosition={"right"} label={"Deactivating crew ..."} /> : null}
            </Stack>;
        }}>
        <Stack tokens={{ childrenGap: 15 }}>
            {!loaded ? <Stack horizontalAlign={"baseline"}><Spinner size={SpinnerSize.medium} labelPosition={"right"} label={"Preparing form ..."} /></Stack> : null}
            {
                loaded && crew ? <>
                    <Text size={'small'}>Are you sure to deactivate {crew.user.name} from {crew.vessel.name}?</Text>
                    <Stack className={'divider'}></Stack>
                    <SelectVessel label={"Vessel"}
                        selected={crew.vessel}
                        onChange={() => {}}
                        disabled />
                    <Stack className={'divider'}></Stack>
                    <SelectEmployee label={"Name"}
                        selected={crew.user}
                        onChange={() => {}}
                        disabled />
                    <SelectVesselCrewRole label={"Role"}
                        selected={crew.role}
                        onChange={() => {}}
                        disabled />
                </> : null
            }
        </Stack>
    </Panel>
};

export default DeactivateVesselCrewForm;
